import styled from "styled-components";

export const MusicHallRegisTermConditionStyled = styled.div`
  .additional_layout {
    margin-bottom: 27px;
    .additional_text1 {
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
    .additional_text2 {
      margin-bottom: 12px;
      color: ${({ theme }) => theme.COLORS.GRAY_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
    }
    .checkbox_layout {
      margin-bottom: 10px;
    }
  }
  .text_area_layout {
    margin-bottom: 20px;
    .text_area_text1 {
      margin-bottom: 2px;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    }
  }
  .upload_layout {
    margin-bottom: 27px;
    .upload_text1 {
      margin-bottom: 13px;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    }
    .upload_input {
      margin-bottom: 13px;
    }
    .upload_text2 {
      margin-bottom: 12px;
      color: ${({ theme }) => theme.COLORS.GRAY_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    }
  }
  .button_layout {
    padding: 0px 42px;
    display: flex;
    justify-content: center;
    column-gap: 36px;
    .button1 {
      flex: 1;
    }
    .button2 {
      flex: 1;
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    .button_layout {
      padding: 0;
      display: flex;
      column-gap: 16px;
    }
  }
`;
